import './marshall.css';
import portableSpeakers from '../../assets/marshall/portableSpeakers.png';
import portableSpeakersBg from '../../assets/marshall/portableSpeakersBg.png';
// import { useLoaderData } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedProduct } from '../../redux/productSlice.js';

function PortableSpeakers() {
  // redux

  const marshallSpeakers = useSelector(
    (state) => state.products.portableSpeakers
  );

  const dispatch = useDispatch();

  const handleClick = (product) => {
    dispatch(setSelectedProduct(product));
  };

  // const navigate = useNavigate();
  // const marshallSpeakers = useLoaderData();
  return (
    <>
      {/* Portable Speaker Heading */}
      <div className="portable-speakers">
        <img src={portableSpeakers} alt="portableSpeakersbg" />
        <h2>
          PORTABLE
          <br />
          SPEAKERS
        </h2>
      </div>

      {/* Portable Speaker Main */}
      <div className="portable-speakers-main">
        <div className="portable-left">
          <div className="psmBg">
            <img src={portableSpeakersBg} alt="portableSpeakersBg" />
          </div>
          <div className="psm-voice">
            <h3>
              PORTABLE
              <br />
              SPEAKERS
            </h3>
            <p className="psm-msg">
              Are you ready to hit the road but in need of wireless solution for
              your music? don’t let cords get in the way of your journey. grab a
              portable, battery-powered Bluetooth speaker From Marshall; turn up
              the volume and live life to the beat of your own soundtrack.
            </p>
          </div>
        </div>
        <div className="portable-right">
          <div className="portable-speakers-item-container">
            {marshallSpeakers.map((speaker) => {
              return (
                <div key={speaker.id} className="mit">
                  <Link
                    to={`/marshall/details/${speaker.type}/${speaker.id}`}
                    onClick={() => handleClick(speaker)}
                  >
                    <img
                      src={speaker.picture}
                      alt="ms1"
                      // onClick={() => navigate('/marshalldetails')}
                    />
                  </Link>
                  <Link
                    to={`/marshall/details/${speaker.type}/${speaker.id}`}
                    className="detail-link"
                    onClick={() => handleClick(speaker)}
                  >
                    <p>{speaker.productName}</p>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default PortableSpeakers;
